// @ts-check
if (!customElements.get("ff-animate-when-visible")) {
  class FfComposition extends HTMLElement {
    constructor() {
      super();

      this.ffInit();
    }

    ffInit() {
      /**
       * @type {NodeListOf<HTMLElement>}
       */
      const animatedElements = this.querySelectorAll(
        this.dataset.ffAnimatedElementsSelector || ""
      );

      if (animatedElements && animatedElements.length > 1) {
        /**
         * @type {HTMLElement[]}
         */
        this.ffAnimatedElements = Array.from(animatedElements);

        const observer = new IntersectionObserver(
          (elements, observer) => {
            elements.forEach(({ isIntersecting, target }) => {
              if (isIntersecting) {
                target.getAnimations().forEach((animation) => {
                  animation.play();
                });
                observer.unobserve(target);
              }
            });
          },
          {
            rootMargin: "0px 0px -50px 0px",
          }
        );

        this.ffAnimatedElements.forEach((element) => {
          element.getAnimations().forEach((animation) => {
            animation.pause();
            animation.currentTime = 0;
          });
          observer.observe(element);
        });
      }
    }
  }

  customElements.define("ff-animate-when-visible", FfComposition);
}
